module.exports = __webpack_public_path__ + "static/index/img/baikal-116.baa8044d.jpg";